import { Text } from '@/components';
import { ErrorMessage as RhfErrorMessage } from '@hookform/error-message';
import type { FC } from 'react';
import type { FieldErrors } from 'react-hook-form';
type Props = {
  errors: FieldErrors;
  name: string;
};

export const ErrorMessage: FC<Props> = ({ errors, name }) => {
  return (
    <div data-dd-privacy="allow">
      <RhfErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <Text variant="footnote" color="error" text={message} />
        )}
      />
    </div>
  );
};
